import { ApolloProvider } from "@apollo/client";
import { CSSReset, ChakraProvider } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { I18nextProvider, useTranslation } from "react-i18next";
import App from "./App";
import { useAppApolloClient } from "./client";
import { GlobalStore } from "./contexts/GlobalContext";
import GlobalStyles from "./styles";
import theme from "./styles/theme";


import i18n from "./utils/i18n";

const Index = React.memo(() => {
    const { t, i18n } = useTranslation();
    const { client } = useAppApolloClient();

    useEffect(() => {
        const lang =
      localStorage.getItem("user-language") ||
      localStorage.getItem("selected-language") ||
      "sq";
        i18n.changeLanguage(lang);
    }, [i18n]);

    return (
        <ApolloProvider client={ client }>
            <GlobalStore>
                <App />
            </GlobalStore>
        </ApolloProvider>
    );
});

ReactDOM.render(
    <I18nextProvider i18n={ i18n }>
        <ChakraProvider theme={ theme }>
            <CSSReset />
            <GlobalStyles />
            <Index />
        </ChakraProvider>
    </I18nextProvider>,
    document.getElementById("root")
);

export default App;
